"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.langfuseAgentPluginsProvider = void 0;
const __1 = require("../..");
const json_1 = require("../../../core/utils/json");
const reasoning_1 = require("../../../core/normalize/message-parts/reasoning");
const normalizeChatMlThinking = (value) => {
    if (value.thinking !== undefined && value.thinking !== null)
        return __1.unmatched;
    return (0, __1.claimed)((0, reasoning_1.reasoningPart)(value.content ?? value.summary, (0, json_1.optionalString)(value.signature)));
};
exports.langfuseAgentPluginsProvider = {
    name: "langfuse-agent-plugins",
    typedParts: { thinking: normalizeChatMlThinking },
    collectSiblingParts: (value, _baseParts, context) => {
        const parts = context.normalizePartList(Array.isArray(value.thinking) ? value.thinking : []);
        return parts.length > 0
            ? [{ sourceKey: "thinking", slot: "after-content", parts }]
            : [];
    },
};
